// extracted by mini-css-extract-plugin
export default {"SecondaryButton":"SecondaryButton_SecondaryButton__jNdDQ"};